import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.25 21.6V18a3.6 3.6 0 0 1 3.6-3.6h6.6m9.3 1.2h-5.4M14.25 6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0"
    />
  </svg>
);
export default SvgUserProfileMinus;
